exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".splitted-class-section {\n\tdisplay: flex;\n\twidth: 100%;\n}\n\n@media only screen and (max-width: 600px) {\n\t.splitted-class-section {\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t}\n}", ""]);

